// export const BASE_URL = "http://127.0.0.1:8000";

export const BASE_URL = "https://wasth.com";
export const IMAGE_BASE_URL = `${BASE_URL}/upload/slideshow`;
export const PROJECT_IMAGE_BASE_URL = `${BASE_URL}/upload/project`;
export const NEWS_IMAGE_BASE_URL = `${BASE_URL}/upload/news`;
export const SHARED_IMAGE_BASE_URL = `${BASE_URL}/upload/shared`;
